import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useCompleteDraftSkuOnSegregation,
  useGetSkuDetail,
  useUpdateProcessFilesOnSku,
} from "../../../hooks/useSeggregation";
import { useGetAllMergedGuidelines } from "../../../hooks/useGuidelines";
import { message } from "antd";
import Button from "../../../common/Button";
import nextIcon from "../../../assets/AddSubCategory/nextIcon.svg";
import { SeggreagtionContext } from "../../../context/seggregationProvider";
import BackIcon from "../../../assets/Header/backIcon.svg";
import Stepper from "../../Stepper";

const SequenceVariant = () => {
  const {
    segg_selectedCategory,
    segg_selectedSubCategory,
    segg_selectedMarketplace,
    segg_selectedVariant,
    segg_setSelectedVariant,
    segg_queryParams,
    segg_setSelectedMarketplace,
  } = useContext(SeggreagtionContext);
  const [skuFiles, setSkuFiles] = useState([]);
  const [skuDetails, setSkuDetails] = useState();
  const [droppedImages, setDroppedImages] = useState([]);
  const [selectedInputs, setSelectedInputs] = useState([]);
  const [draggedOverAngleId, setDraggedOverAngleId] = useState(null);
  const [allCompleteSku, setAllCompleteSku] = useState(false);
  const [richTextHtml, setRichTextHtml] = useState();
  const params = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (segg_selectedMarketplace?.id) {
      const selectedMarketplace = skuDetails?.toProcessFilesDraft?.find(
        (marketplace) =>
          marketplace?.marketplace?._id === segg_selectedMarketplace?.id
      );
      if (selectedMarketplace && !selectedMarketplace?.isCompleted) {
        selectedMarketplace.isCompleted = true;
      }
    }
    const allCompleted = skuDetails?.toProcessFilesDraft?.every(
      (marketplace) => marketplace?.isCompleted
    );
    setAllCompleteSku(allCompleted);
  }, [segg_selectedMarketplace?.id, skuDetails?.toProcessFilesDraft]);
  const onSuccessGetSkuDetails = (res) => {
    if (res?.status === 200) {
      setSkuFiles(res?.data?.skuFiles);
      setSkuDetails(res?.data?.draftSku);
      setRichTextHtml(res?.data?.batch?.richTextDescriptionHtml?.url);
    }
  };
  const onErrorGetSkuDetails = (err) => {
    console.log(err);
  };
  const { data: getSkuDetails } = useGetSkuDetail(
    "getSKudetails",
    params?.skuId,
    onSuccessGetSkuDetails,
    onErrorGetSkuDetails
  );
  const handleDragStart = (e, skuFile) => {
    e.dataTransfer.setData("skuFile", JSON.stringify(skuFile));
  };
  const handleDragOver = (e, angleId) => {
    e.preventDefault();
    setDraggedOverAngleId(angleId);
  };

  const handleDragLeave = () => {
    setDraggedOverAngleId(null);
  };

  const handleDrop = (e, angleId) => {
    setDraggedOverAngleId(null);
    e.preventDefault();
    const skuFile = JSON.parse(e.dataTransfer.getData("skuFile"));

    setDroppedImages((prevImages) => {
      const existingAngle = prevImages.find(
        (image) => image.angleId === angleId
      );
      if (
        existingAngle &&
        existingAngle.referenceFiles?.some((sku) => sku._id === skuFile._id)
      ) {
        message.error("Duplicate not allowed");
        return prevImages;
      }

      if (existingAngle) {
        if (!existingAngle.mainFile) {
          return prevImages.map((image) =>
            image.angleId === angleId ? { ...image, mainFile: skuFile } : image
          );
        } else {
          return prevImages.map((image) =>
            image.angleId === angleId
              ? { ...image, referenceFiles: [...image.referenceFiles, skuFile] }
              : image
          );
        }
      } else {
        return [
          ...prevImages,
          {
            angleId,
            mainFile: skuFile,
            referenceFiles: [],
          },
        ];
      }
    });

    setSelectedInputs((prevSelected) => {
      const skuFileExists = prevSelected?.some(
        (file) => file?._id === skuFile?._id
      );
      if (!skuFileExists) {
        return [...prevSelected, skuFile];
      }
      return prevSelected;
    });
  };
  const onSuccessCompleteDraftSkuOnSegregation = (res) => {
    if (res.status === 200) {
      message.success("Sku Completed");
      navigate(`/seggregation-batch-loading/${segg_queryParams}`);
    }
  };

  const onErrorCompleteDraftSkuOnSegregation = (err) => {
    console.log(err);
  };
  const { mutate: completeDraftSkuOnSegregation } =
    useCompleteDraftSkuOnSegregation(
      onSuccessCompleteDraftSkuOnSegregation,
      onErrorCompleteDraftSkuOnSegregation
    );
  const onSuccessUpdateProcessFilesOnSku = (res) => {
    if (res.status === 200) {
      if (segg_selectedMarketplace?.id) {
        const selectedMarketplace = skuDetails?.toProcessFilesDraft?.find(
          (marketplace) =>
            marketplace?.marketplace?._id === segg_selectedMarketplace?.id
        );
        if (selectedMarketplace && !selectedMarketplace?.isCompleted) {
          selectedMarketplace.isCompleted = true;
        }
      }
      const allCompleted = skuDetails?.toProcessFilesDraft?.every(
        (marketplace) => marketplace?.isCompleted
      );
      setAllCompleteSku(allCompleted);
      if (allCompleted && skuDetails?.addOnServices?.length === 0) {
        message.success("Process file updated on SKU");
        // navigate(`/select-add-on/${params?.skuId}`);
        completeDraftSkuOnSegregation(params?.skuId);
      } else if (allCompleted && skuDetails?.addOnServices?.length > 0) {
        message.success("Process file updated on SKU");
        navigate(`/select-add-on/${params?.skuId}`);
        // completeDraftSkuOnSegregation(params?.skuId);
      } else {
        segg_setSelectedVariant("");
        message.success("Process file updated on SKU");
        navigate(`/select-variant/${params?.skuId}`);
      }
    }
  };

  const onErrorUpdateProcessFilesOnSku = (err) => {
    console.log(err);
  };
  const { mutate: updateProcessFilesOnSku } = useUpdateProcessFilesOnSku(
    onSuccessUpdateProcessFilesOnSku,
    onErrorUpdateProcessFilesOnSku
  );
  const handleNext = () => {
    segg_setSelectedMarketplace("");
    let toProcessFiles = droppedImages.map((dropped) => ({
      angleId: dropped?.angleId,
      mainFileId: dropped?.mainFile._id,
      referenceFileIds: dropped?.referenceFiles._id,
    }));

    let payload = {
      draftSkuId: params?.skuId,
      marketplaceId: segg_selectedMarketplace?.id,
      guidelineId: params?.guidelineId,
      angleSetId: segg_selectedVariant?._id,
      toProcessFiles: toProcessFiles,
    };
    updateProcessFilesOnSku(payload);
  };
  const handleDeleteItem = (angleId, droppedSkuId) => {
    setDroppedImages((prevImages) => {
      const updatedImages = prevImages
        .map((image) => {
          if (image.angleId === angleId) {
            if (image.mainFile && image.mainFile._id === droppedSkuId) {
              return { ...image, mainFile: null };
            } else {
              return {
                ...image,
                referenceFiles: image.referenceFiles.filter(
                  (sku) => sku._id !== droppedSkuId
                ),
              };
            }
          }
          return image;
        })
        .filter((image) => image.mainFile || image.referenceFiles.length > 0);
      setSelectedInputs((prevSelected) => {
        const skuStillExists = updatedImages?.some(
          (image) =>
            (image.mainFile && image.mainFile._id === droppedSkuId) ||
            image.referenceFiles.some((sku) => sku._id === droppedSkuId)
        );
        if (!skuStillExists) {
          return prevSelected.filter((file) => file._id !== droppedSkuId);
        }
        return prevSelected;
      });

      return updatedImages;
    });
  };

  return (
    <div className="sequence_variant_main_wrapper">
      <div className="sequence_variant_header">
        <div className="left_wrapper">
          <div className="content_wrapper">
            <div className="title">Category</div>
            <div className="title_value">{segg_selectedCategory?.name}</div>
          </div>
          <div className="content_wrapper">
            <div className="title">Sub Category</div>
            <div className="title_value">{segg_selectedSubCategory?.name}</div>
          </div>
        </div>
        <div className="right_wrapper">
          <div className="content_wrapper">
            <div className="title">Marketplace</div>
            <div className="market_place_wrapper">
              {skuDetails?.toProcessFilesDraft?.length > 0 &&
                skuDetails?.toProcessFilesDraft?.map((marketplace, index) => {
                  return (
                    <>
                      <div
                        className={`marketplace_title ${
                          marketplace?.isCompleted ||
                          segg_selectedMarketplace?.id ===
                            marketplace?.marketplace?._id
                            ? "active_marketplace"
                            : ""
                        }`}
                        key={marketplace?.marketplace?._id}
                      >
                        {marketplace?.marketplace?.name}
                      </div>
                      {skuDetails?.toProcessFilesDraft?.length - 1 !==
                        index && <div className="continue_line" />}
                    </>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="sequence_variant_content_wrapper">
        <div className="left_container">
          <div className="content_wrapper">
            <div className="title">{skuDetails?.displayName}</div>
            <div className="images_list_wrapper">
              {skuFiles.length > 0 &&
                skuFiles.map((skuFile, index) => {
                  return (
                    <div
                      className="image_wrapper"
                      draggable
                      onDragStart={(e) => handleDragStart(e, skuFile)}
                      key={index}
                    >
                      <img
                        src={skuFile?.image?.thumbPath.url}
                        alt={skuFile?.image?.name}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="content_wrapper">
            <div className="title">Selected Input</div>
            <div className="images_list_wrapper">
              {selectedInputs?.length > 0 &&
                selectedInputs?.map((selectedInput, index) => {
                  return (
                    <div
                      className="image_wrapper"
                      onDragStart={(e) => handleDragStart(e, selectedInput)}
                    >
                      <img
                        src={selectedInput?.image?.thumbPath.url}
                        alt={selectedInput?.image?.name}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="right_container">
          <div className="content_wrapper">
            <div className="title">
              {segg_selectedMarketplace?.name} Image Sequence
              {/* <Button
                text="Create Set"
                width={"150px"}
                height={"40px"}
                // handleClick={() => {
                //   guide_setSelectedCategoryId();
                //   guide_setSelectedSubCategoryId();
                //   guide_setSelectedSubCategoryId();
                // }}
              /> */}
              {richTextHtml && (
                <Link
                  onClick={() => {
                    window.open(richTextHtml);
                  }}
                >
                  View Batch Description
                </Link>
              )}
            </div>
            <div className="list_container">
              <div className="variant_card_wrapper">
                <div className="variant_card_content">
                  <div className="variant_header">
                    <div className="card_title">Variant </div>
                  </div>
                  <div className="variant_images_list">
                    {segg_selectedVariant?.angles?.length > 0 &&
                      segg_selectedVariant.angles.map((angle) => {
                        const droppedImage = droppedImages.find(
                          (image) => image?.angleId === angle?._id
                        );
                        const hasMainFile = droppedImage?.mainFile;
                        const hasReferenceFiles =
                          droppedImage?.referenceFiles?.length > 0;

                        return (
                          <div
                            className={`image_main_wrapper ${
                              draggedOverAngleId === angle._id
                                ? "drag_drop_border"
                                : ""
                            }`}
                            key={angle._id}
                            onDrop={(e) => handleDrop(e, angle._id)}
                            onDragOver={(e) => handleDragOver(e, angle._id)}
                            onDragLeave={handleDragLeave}
                          >
                            <div className="image">
                              <img
                                src={angle?.angleGlobal?.image?.thumbPath?.url}
                                alt=""
                              />
                            </div>

                            <div className="image_sub_list_wrapper">
                              {hasMainFile && (
                                <div className="sub_image mainFile">
                                  <img
                                    src={hasMainFile?.image?.thumbPath?.url}
                                    alt={hasMainFile?.image?.name}
                                  />
                                  <div
                                    className="cross-icon"
                                    onClick={() =>
                                      handleDeleteItem(
                                        angle._id,
                                        hasMainFile._id
                                      )
                                    }
                                  />
                                </div>
                              )}

                              {hasReferenceFiles &&
                                droppedImage.referenceFiles.map(
                                  (droppedSku) => (
                                    <div
                                      className="sub_image"
                                      key={droppedSku._id}
                                    >
                                      <img
                                        src={droppedSku?.image?.thumbPath?.url}
                                        alt={droppedSku?.image?.name}
                                      />
                                      <div
                                        className="cross-icon"
                                        onClick={() =>
                                          handleDeleteItem(
                                            angle._id,
                                            droppedSku._id
                                          )
                                        }
                                      />
                                    </div>
                                  )
                                )}
                            </div>
                            {!hasMainFile && !hasReferenceFiles && (
                              <div className="drop_msg_container">
                                Drop SKU here
                              </div>
                            )}
                            <div className="image_title">
                              {angle?.adaptation?.name}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom_panel">
              <Stepper
                isSeggregation={true}
                activeStep={2}
                isSeggAddOn={
                  skuDetails?.addOnServices?.length === 0 ? false : true
                }
              />
              <div className="action_container">
                <button
                  className="backBtn"
                  onClick={() => navigate(`/select-variant/${params?.skuId}`)}
                >
                  <img src={BackIcon} alt="backBtn" />
                </button>
                <Button
                  width="195px"
                  text={
                    allCompleteSku && skuDetails?.addOnServices?.length === 0
                      ? "Complete"
                      : "Next"
                  }
                  height="55px"
                  showIcon={
                    allCompleteSku && skuDetails?.addOnServices?.length === 0
                      ? false
                      : true
                  }
                  iconImage={nextIcon}
                  handleClick={() => handleNext()}
                  isDisabled={
                    droppedImages.length ===
                      segg_selectedVariant?.angles?.length &&
                    droppedImages.every((image) => image?.mainFile)
                      ? false
                      : true
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SequenceVariant;
